import { FC } from "react";
import { Button, Dialog, Flex, Image, Text, VStack } from "@chakra-ui/react";

import psr from "@assets/files/images/cases/psr.png";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";
import { CloseButton } from "@shared/components";

interface UploadCaseModalSuccessProps {
  onSubmit: () => void;
}

const UploadCaseModalSuccessModal: FC<UploadCaseModalSuccessProps> = ({ onSubmit }) => {
  return (
    <>
      <Dialog.Header pt={6}>
        <Flex justify="center">
          <Image src={psr} alt="PSR" />
        </Flex>
        <Dialog.CloseTrigger asChild>
          <CloseButton color="grey.10" />
        </Dialog.CloseTrigger>
      </Dialog.Header>
      <Dialog.Body pb={6}>
        <Text
          textStyle="subtitle"
          textAlign="center"
          color="brand.modalHeaderText"
          letterSpacing="unset"
          lineHeight="normal"
        >
          Your document was received!
        </Text>
        <VStack mt={2} textAlign="center" gap={2} fontSize="14px">
          <Text color="brand.activeColor" fontWeight={FONT_WEIGHT.BOLD}>
            Prisonology’s BOP experts are reviewing your file.
          </Text>
          <Text pb={4}>You will receive an email confirmation when your report is ready for download.</Text>
          <Button w="100%" variant="primary" onClick={onSubmit}>
            Got It
          </Button>
        </VStack>
      </Dialog.Body>
    </>
  );
};

export default UploadCaseModalSuccessModal;
